export enum MessageType {
  ERROR = 'ERROR',
  HELP = 'HELP',
  WARNING = 'WARNING',
  INFO = 'INFO',
  DEBUG = 'DEBUG',
}

export enum FeedbackChannels {
  UPDATE = 'UPDATE',
  PUBLISH = 'PUBLISH',
}

export type Feedback = {
  context: string;
  type: MessageType;
  text: string;
  code?: string;
};

export type FieldFeedback = {
  channel?: FeedbackChannels;
  types?: Set<MessageType>;
  hasWhatTypeOfFeedbackByIndex?: Map<string, Set<MessageType>>;
  feedbacks?: Feedback[];
};

export type FeedbackMap = Map<string, FieldFeedback>;
